/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
import { Decimal } from 'decimal.js';

import type { BookingProps } from './booking/booking.schema';

export const cashToPoints = (cash: Decimal, tiers: BookingProps['reservation']['offer']['pointsTierInstance']) => {
  const absCash = new Decimal(cash).abs();
  const points = tiers.levels
    .reduce((total, tier) => {
      if (absCash.greaterThanOrEqualTo(tier.min as any)) {
        const tierMax = (max: number) => (max ? max : new Decimal(Infinity));
        const pointsAmountForTier = Decimal.min(tierMax(tier.max as number), absCash)
          .minus(tier.min as any)
          .dividedBy(tier.rate as any);
        return total.plus(pointsAmountForTier);
      }
      return total;
    }, new Decimal(0))
    .toDecimalPlaces(0, Decimal.ROUND_HALF_EVEN);

  return cash.isNegative() ? points.neg() : points;
};
